// src/api/axiosConfig.js
import { onHandleLogout } from '@/services/common';
import axios from 'axios';

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || 'http://stagingapi.partment.co/api';
const DEFAULT_API_VERSION = 'v1'; // Default API version

// Create an Axios instance with default configuration
const axiosInstance = axios.create({
    baseURL: `${API_BASE_URL}/${DEFAULT_API_VERSION}`, // Default base URL with v1
    headers: { 'Content-Type': 'application/json', },
});

// Request interceptor
axiosInstance.interceptors.request.use(config => {
    if (config.authRequired) {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }

    if (config.version) {
        config.baseURL = `${API_BASE_URL}/${config.version}`;
    }

    return config;
});

// Response interceptor
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            onHandleLogout()
            // Handle token refresh here if needed
            // localStorage.removeItem('access_token');
            // localStorage.removeItem('refresh_token');
            // window.location.href = '/login'; // Redirect to login
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;